<template>
    <div class="optimization-result text-center" v-if="isVisible">
        <i class="fad fa-spinner fa-pulse primary-color fz-48 m-b-24"></i>
        <h3 class="m-b-8">{{ $t('optimize_image.modal_optimization_result.title') }}</h3>
        <p class="m-b-16"
            v-html="onBoardingScreen ? $t('optimize_image.modal_optimization_result.onboarding_description') : $t('optimize_image.modal_optimization_result.app_description')"
        >
        </p>
        <a-button type="primary" @click="doAction"> 
            {{ onBoardingScreen ? $t('optimize_image.modal_optimization_result.onboarding_btn') : $t('optimize_image.modal_optimization_result.got_it')}}
        </a-button>
    </div>
</template>

<script>

export default {
    name: 'OptimizationResult',
    props:{
        value: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        isVisible: {
            get() {
                return this.value
            },
            set: function(newValue) {
                this.$emit('input', newValue)
            }
        },
        onBoardingScreen() {
            return this.$router.currentRoute.name == this.$routerName.ONBOARD_SET_UP
        }
    },
    data(){
        return{
        }
    },

    created() {
    },

    methods:{
        doAction() { 
            this.isVisible = false
            this.$emit('go-dashboard')
        }
    }
}
</script>

<style lang="scss">
    .optimization-result {
    }
</style>